/*
export const someMutation = (state) => {}
 */
export var SET_USERDATA = function SET_USERDATA(state, data) {
  state.data = data;
};
export var SET_USERLASTREQUEST = function SET_USERLASTREQUEST(state, data) {
  state.data.lastRequest = data;
};
export var CLEAR_USERDATA = function CLEAR_USERDATA(state) {
  state.data = {};
};